import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';

const COPYRIGHT_TEXT = '\u00A9 2026 Simply SLPs, LLC. All rights reserved. FrameEd, Frame Practice, Frame Interventions, Frame IEP/MET, Rubric Builder, Speech/Language Referral Manager, and related products, software, designs, documentation, templates, workflows, and content are proprietary to Simply SLPs, LLC.';

export function LegalFooter({ variant = 'full' }) {
  if (variant === 'compact') {
    return (
      <footer className="py-4 px-6 border-t border-[#E5E5E5] bg-[#FDFCFB]" data-testid="legal-footer">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-[10px] text-[#999]">
          <span>{'\u00A9'} 2026 Simply SLPs, LLC. All rights reserved.</span>
          <Link to="/legal" className="hover:text-[#595959] transition-colors underline-offset-2 hover:underline">Legal & IP Notice</Link>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-[#1C1C1C]" data-testid="legal-footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="py-10 flex flex-col md:flex-row items-start justify-between gap-8">
          <div className="flex items-center gap-2 shrink-0">
            <GraduationCap className="h-6 w-6 text-white" />
            <span className="font-outfit text-xl font-semibold text-white">FrameEd</span>
          </div>
          <div className="flex flex-col items-end gap-2 text-right">
            <Link to="/legal" className="text-xs text-[#888] hover:text-white transition-colors underline-offset-2 hover:underline">
              Legal & IP Notice
            </Link>
          </div>
        </div>
        <div className="border-t border-white/10 py-5">
          <p className="text-[10px] text-[#666] leading-relaxed max-w-4xl">
            {COPYRIGHT_TEXT}
          </p>
        </div>
      </div>
    </footer>
  );
}
